export const urlHint = 'Must be a valid URL'

export const validateUrl = (value: string) => {
  //
  // Empty value passes so the field is optional; combine with the
  // `required` validation to also enforce presence.
  //
  if (!value) {
    return true
  }
  // Prepend a scheme when one is missing so bare domains (example.com,
  // www.example.com) still validate — matching prior lenient behavior.
  const candidate = value.includes('://') ? value : `https://${value}`
  try {
    const { hostname } = new URL(candidate)
    // Require a dotted hostname (a TLD), as the previous regex did, so
    // single tokens like "foo" or "localhost" are rejected.
    return hostname.includes('.') || urlHint
  } catch {
    return urlHint
  }
}
